import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHelperService } from '../../utilities/http-helper/http-helper.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StyistService {

  constructor(
    private http: HttpClient,
    private httpHelper: HttpHelperService
  ) { }

  onboardStylist(data): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Stylists/CreateOnBoardingStylist`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }

  stylistEmail(data): Observable<any> {
    const apiUrl = this.httpHelper.getApiUrl(`/api/Stylists/OnboardingSylistEmail`);
    const requestOptions: Object = {
      responseType: 'text'
    }
    return this.http.post(apiUrl, data, requestOptions);
  }

}
